import AbstractApi from '@/api/abstracts/AbstractApi'
import httpClient from '@/utilities/service/httpClient'
import { BidNumber } from '@/api/types/general/GeneralType'
// eslint-disable-next-line prettier/prettier
import type { BidDecisionCriteriaType } from '@/api/types/response/BidDecisionCriteriaType'
import type { SubmitDecisionPayloadType, FinalDecisionPayloadType } from '@/api/types/request/SubmitDecisionPayloadType'
import type { SubmitDecisionType } from '@/api/types/response/SubmitDecisionType'

/**
 * @property string apiEnd /api/sales/decision
 */
export default class DecisionApi extends AbstractApi {
  criteriaSets(): Promise<BidDecisionCriteriaType> {
    return httpClient.get(`${this.apiEnd}/criterias`)
  }

  decisionSet(bidNumber: BidNumber): Promise<BidDecisionCriteriaType> {
    return httpClient.get(`${this.apiEnd}/${bidNumber}`)
  }

  submit(payload: SubmitDecisionPayloadType): Promise<SubmitDecisionType> {
    return httpClient.post(`${this.apiEnd}/submit`, payload)
  }

  approval(payload: FinalDecisionPayloadType): Promise<SubmitDecisionType> {
    return httpClient.post(`${this.apiEnd}/approval`, payload)
  }
}
